import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("dialog", {
    class: "c-dialog",
    ref: "dialog",
    onClose: _cache[0] || (_cache[0] = $event => (_ctx.$emit('hide'))),
    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onBackdropClick && _ctx.onBackdropClick(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 544 /* NEED_HYDRATION, NEED_PATCH */))
}